import { Dispatch } from 'redux';
import { Service } from 'components/Shared/server';

export const STEP_NEXT = 'STEP_NEXT';
export const STEP_PREV = 'STEP_PREV';
export const STEP_ADDINGTOCART = 'STEP_ADDINGTOCART';
export const STEP_ADDEDTOCART = 'STEP_ADDEDTOCART';
export const STEP_SAVECONFIGURATION = 'STEP_SAVECONFIGURATION';
export const STEP_SAVECONFIGURATION_DONE = 'STEP_SAVECONFIGURATION_DONE';

export interface ISaveConfiguration {
  state: string;
  cartId: string;
}

export const stepNext = () => ({
  type: STEP_NEXT
});

export const stepPrev = () => ({
  type: STEP_PREV
});

export const stepAddingToCart = () => ({
  type: STEP_ADDINGTOCART
});

export const stepAddedToCart = () => ({
  type: STEP_ADDEDTOCART
});

export const stepSaveConfigurationDone = () => ({
  type: STEP_SAVECONFIGURATION_DONE
});

export const stepSaveConfiguration = (data: ISaveConfiguration) => {
  return (dispatch: Dispatch) => {
    void Service.post<ISaveConfiguration>({
      url: '/conservatory/saveconfiguration',
      body: data
    }).then(() => dispatch(stepSaveConfigurationDone()));
  };
};
